// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modal-quickorder{left:0;top:50%;width:25vw;right:0;margin:0 auto;transform:translateY(-50%)}@media only screen and (max-width:768px){#modal-quickorder{width:80%!important}}", ""]);
// Exports
module.exports = exports;
